module.exports = __webpack_public_path__ + "static/media/refer.a34ddc6a.svg";